export const companyPositions = [
  { value: '', label: '選択してください' },
  { value: '理事長', label: '理事長' },
  { value: '理事', label: '理事' },
  { value: '院長', label: '院長' },
  { value: '副院長', label: '副院長' },
  { value: '事務長', label: '事務長' },
  { value: '勤務医', label: '勤務医' },
  { value: '歯科衛生士', label: '歯科衛生士' },
  { value: '歯科助手', label: '歯科助手' },
  { value: '受付・事務', label: '受付・事務' },
  { value: 'その他の医療従事者', label: 'その他の医療従事者' },
  { value: '医療関係企業従事者', label: '医療関係企業従事者' },
];

export const startPrace = [
  { value: '', label: '選択してください' },
  {
    value: '新規開業（分院開業）予定はない',
    label: '新規開業（分院開業）予定はない',
  },
  {
    value: '新規開業を検討している',
    label: '新規開業を検討している',
  },
  {
    value: '分院開業を検討している',
    label: '分院開業を検討している',
  },
  {
    value: '家族継承を検討している',
    label: '家族継承を検討している',
  },
];

export const statusVisit = [
  { value: '', label: '選択してください' },
  {
    value: '実施してない (今後予定なし)',
    label: '実施してない (今後予定なし)',
  },
  {
    value: '実施してない (今後予定あり)',
    label: '実施してない (今後予定あり)',
  },
  {
    value: '実施している (月5名未満)',
    label: '実施している (月5名未満)',
  },
  {
    value: '実施している (月5名以上)',
    label: '実施している (月5名以上)',
  },
];
